import { render, staticRenderFns } from "./SearchPage.vue?vue&type=template&id=4f2954bc"
import script from "./SearchPage.vue?vue&type=script&lang=js"
export * from "./SearchPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports